export default "__VITE_PUBLIC_ASSET__9eb39bfc__"